module.exports = __webpack_public_path__ + "img/harmony_01.a0eea279.jpg";